export default {
  "nav": {
    "telecom": "电信",
    "telecomInfrastructures": "基础设施",
    "telecomFibre": "光纤网络",
    "telecomMaintenance": "维护服务",
    "genieCivilBTP": "土木工程与建筑",
    "home": "首页",
    "solutions": "解决方案",
    "projets": "项目案例",
    "aPropos": "关于我们",
    "contact": "联系我们",
    "getQuote": "获取报价"
  },
  "footer": {
    "telecomList": {
      "towers": "塔楼与甕杆",
      "fibre": "光纤光缆",
      "maintenance": "NOC维护"
    },
    "tagline": "自2006年以来，IS TELECOM一直是电信基础设施和能源解决方案的领导者。我们连接社区，推动可持续发展。",
    "subscribe": "订阅",
    "subscribePlaceholder": "您的邮箱",
    "services": "服务",
    "servicesList": {
      "microgrids": "微电网",
      "solarPumping": "太阳能抽水",
      "storage": "储能",
      "evCharging": "电动车充电",
      "constructionMetal": "金属结构与土木工程",
      "itNetworks": "信息技术与网络",
      "audit": "审计与咨询",
      "telecom": "电信",
      "transport": "运输与物流",
      "expertise": "技术专长"
    },
    "company": "公司",
    "companyList": {
      "about": "关于我们",
      "projects": "我们的项目",
      "products": "产品",
      "contact": "联系方式"
    },
    "contact": "联系方式",
    "copyright": "© 2026 IS TELECOM。保留所有权利。",
    "terms": "使用条款",
    "privacy": "隐私政策",
    "ctaTitle1": "电信与能源",
    "ctaTitle2": "基础设施",
    "ctaTitle3": "适用于每个地区",
    "ctaButton": "获取报价"
  },
  "hero": {
    "badge": "{ 能源与电信 }",
    "titleLine1": "能源与",
    "titleLine2": "电信",
    "titleLine3": "解决方案",
    "subtitle": "自2006年以来，IS TELECOM在非洲6个国家部署电信基础设施和能源解决方案。",
    "cta": "获取报价"
  },
  "overview": {
    "badge": "关于IS TELECOM",
    "titleLine1": "每个太阳能项目",
    "titleLine2": "每个基础设施项目",
    "description": "我们的多学科团队结合电信和能源专业知识，提供可靠的基础设施解决方案。从传输塔到太阳能微电网，我们连接社区并推动可持续发展。",
    "learnMore": "了解更多",
    "statYears": "年经验",
    "statCountries": "服务国家",
    "statProjects": "完成项目"
  },
  "features": {
    "badge": "特点",
    "title": "三大专长，一个使命：建设非洲的未来",
    "items": [
      {"title": "电信基础设施"},
      {"title": "土木工程与建筑"},
      {"title": "互联服务"}
    ]
  },
  "services": {
    "badge": "我们的服务",
    "title": "为您量身定制的解决方案",
    "description": "从太阳能到电信、建筑和运输，我们的多学科专业知识涵盖您所有的基础设施项目。",
    "list": [
      {"title": "太阳能评估", "tags": ["太阳能", "咨询"]},
      {"title": "太阳能板安装", "tags": ["太阳能", "安装"]},
      {"title": "电池储能", "tags": ["太阳能", "储能"]},
      {"title": "监控与支持", "tags": ["太阳能", "监控"]},
      {"title": "金属结构与土木工程", "tags": ["土木", "建筑"]},
      {"title": "信息技术与网络", "tags": ["IT", "网络"]},
      {"title": "审计与咨询", "tags": ["审计", "咨询"]},
      {"title": "电信", "tags": ["电信", "基础设施"]},
      {"title": "运输与物流", "tags": ["物流", "运输"]}
    ]
  },
  "projects": {
    "badge": "我们的项目",
    "title": "我们的近期成果",
    "viewDetails": "查看详情",
    "list": [
      {
        "category": "微电网",
        "year": "2023年",
        "title": "村庄 — 农村电气化",
        "description": "量身定制的太阳能系统，降低能源成本，为您的社区带来清洁能源。"
      },
      {
        "category": "电信",
        "year": "2025年",
        "title": "运营商 — 国家电信网络",
        "description": "为200个站点部署太阳能供电的电信基础设施，确保城乡地区的可靠连接。"
      },
      {
        "category": "监控",
        "year": "2024年",
        "title": "智能 — 高级监控",
        "description": "通过连接的太阳能安装系统跟踪系统性能，帮助您了解每千瓦的产出。"
      }
    ]
  },
  "partners": {
    "badge": "我们的合作伙伴",
    "title": "他们信任我们",
    "description": "电信、能源和技术领域的全球领导者与IS TELECOM合作，在非洲部署可持续解决方案。"
  },
  "process": {
    "badge": "流程",
    "title": "从研究到投入使用",
    "description": "我们从初步审计到全面投入使用全程陪伴您，无论是电信基础设施还是能源项目。",
    "stepPrefix": "步骤",
    "steps": [
      {"title": "研究与工程", "description": "我们分析您的需求，研究地形，为您的基础设施项目设计详细的工程计划。"},
      {"title": "建设与安装", "description": "我们认证的团队进行土木工程、架设结构并精确安全地安装设备。"},
      {"title": "测试与调试", "description": "我们严格测试每个组件，验证性能，确保您的基础设施全面投入使用。"}
    ]
  },
  "testimonials": {
    "badge": "客户评价",
    "titleLine1": "值得信赖的合作伙伴，",
    "titleLine2": "可靠的基础设施",
    "verifiedReviews": "条已验证评价",
    "items": [
      {"quote": "IS TELECOM为我们在塞内加尔的网络部署了200多个站点。他们的团队完美掌握华为设备，即使在最难进入的区域也按时完成了所有工作。", "name": "Ahmadou Diallo", "role": "网络总监，MTN 塞内加尔"},
      {"quote": "他们在我们光纤骨干网上的工作质量令人瞩目。无可挑剔的OTDR测试、完整的文档，以及一个对爱立信标准了如指掌的团队。", "name": "Amina Diallo", "role": "基础设施经理，Orange CI"},
      {"quote": "他们的全天候NOC支持至关重要。当站点在凌晨3点出现故障时，IS TELECOM团队凌晨5点就已到达现场。这是独一无二的响应水平。", "name": "Koffi Agbessi", "role": "技术总监，Moov Africa"},
      {"quote": "我们将150个站点的4G现代化升级委托给他们。团队培训、安装、无线优化——一切都按时交付，质量超出我们的预期。", "name": "Fatou Beye博士", "role": "首席技术官，Airtel Senegal"},
      {"quote": "IS TELECOM是我们桅杆的参考合作伙伴。他们的结构坚固，符合抗震标准，土木工程无可挑剔。真正的高质量工作。", "name": "Moussa Coulibaly", "role": "部署经理，Vodacom"},
      {"quote": "FTTH部署快速且整洁。3个月内，他们完成了我们整个城区的布线。他们的GPON专业知识和项目管理令人印象深刻。", "name": "Sophie Lawson", "role": "CEO，Togocom"}
    ]
  },
  "faq": {
    "badge": "常见问题",
    "title": "常见问题解答",
    "homeFaqs": [
      {"q": "01. IS TELECOM提供哪些电信服务？", "a": "我们部署完整的电信基础设施：铁塔和桅杆、光纤网络、无线设备维护以及城乡连接解决方案。作为华为、爱立信和MTN的合作伙伴，我们覆盖整个电信产业链。"},
      {"q": "02. 您在哪些国家运营？", "a": "IS TELECOM在西非和东非的6个非洲国家开展业务：贝宁、多哥、马里、赞比亚、坦桑尼亚和塞内加尔。我们在这些国家都设有办事处，并在当地开展电信和能源项目。"},
      {"q": "03. 你们安装哪些类型的电信铁塔？", "a": "我们设计和安装所有类型的桅杆：自支撑式（高达120米）、拉线式、城市单极式和管状桅杆。每个安装均符合国际ANSI/TIA-222标准。"},
      {"q": "04. 你们提供电信维护合同吗？", "a": "当然。我们的维护合同包括计划性预防干预、全天候NOC支持、4小时内纠正性干预（保证SLA）和完整的备件管理。"}
    ]
  },
  "contact": {
    "pageTitle": "联系我们",
    "pageSubtitle": "准备部署您的电信基础设施或能源项目了吗？我们的团队随时为您提供帮助",
    "infoPhone": "电话",
    "infoEmail": "邮箱",
    "infoAddress": "地址",
    "infoHours": "工作时间",
    "hoursLine1": "周一至周五：8:00 - 18:00",
    "hoursLine2": "NOC支持：全天候",
    "formTitle": "给我们留言",
    "formSubtitle": "填写下方表格，我们的团队将在24小时内回复您。",
    "formSuccess": "消息已发送！",
    "formSuccessMsg": "我们会尽快回复您。",
    "labelName": "全名",
    "placeholderName": "您的姓名",
    "labelEmail": "邮箱",
    "placeholderEmail": "your@email.com",
    "labelPhone": "电话",
    "placeholderPhone": "+229 XX XX XX XX",
    "labelSubject": "主题",
    "subjectOptions": {
      "info": "一般信息",
      "tech": "技术信息",
      "partnership": "合作伙伴",
      "careers": "招聘",
      "other": "其他"
    },
    "labelMessage": "消息",
    "placeholderMessage": "描述您的项目或问题...",
    "sending": "发送中...",
    "send": "发送消息",
    "quickResponse": "需要快速回答？",
    "freeQuote": "免费报价：",
    "freeQuoteDesc": "任何基础设施项目在48个工作小时内收到估算。",
    "techSupport": "技术支持：",
    "techSupportDesc": "我们的NOC全天候为持有维护合同的客户提供服务。",
    "siteVisit": "现场访问：",
    "siteVisitDesc": "我们免费上门评估您的基础设施需求。",
    "faqTitle": "常见问题",
    "contactFaqs": [
      {"q": "电信站点部署需要多长时间？", "a": "标准站点在工程研究后需要2到4周。对于光纤骨干或多站点项目，时间表根据项目范围定制。"},
      {"q": "你们提供电信维护服务吗？", "a": "是的，我们所有合同都包括计划性预防维护和全天候NOC支持，保证4小时内干预。我们还提供延长维护合同。"},
      {"q": "获得报价需要多长时间？", "a": "我们在收到您的请求后48个工作小时内发送详细报价。复杂项目可能需要技术现场访问。"},
      {"q": "你们在非洲以外地区工作吗？", "a": "我们的业务集中在6个非洲国家：贝宁、多哥、马里、赞比亚、坦桑尼亚和塞内加尔。这种有针对性的存在使我们能够在这些市场中提供本地化专业知识和最佳响应能力。"},
      {"q": "你们有什么认证？", "a": "我们拥有ISO 9001和ISO 14001认证。我们的团队由华为、爱立信和诺基亚培训和认证。所有安装均符合ANSI/TIA-222标准。"}
    ]
  },
  "devis": {
    "pageTitle": "申请您的个性化报价",
    "pageSubtitle": "描述您的电信或能源基础设施项目，在48小时内收到详细估算，无任何义务",
    "badge": "免费报价",
    "advantages": [
      {"text": "48小时内回复"},
      {"text": "免费且无义务报价"},
      {"text": "由我们的专家进行个性化研究"},
      {"text": "在6个非洲国家运营"}
    ],
    "step1Title": "第1步：您的信息",
    "step2Title": "第2步：您的项目",
    "step3Title": "第3步：摘要",
    "labelName": "全名",
    "labelCompany": "公司/组织",
    "placeholderCompany": "您的公司名称",
    "labelEmail": "邮箱",
    "labelPhone": "电话",
    "labelLocation": "项目地点",
    "placeholderLocation": "城市，国家",
    "labelProjectType": "项目类型",
    "selectProject": "选择项目类型",
    "labelBudget": "预估预算",
    "selectBudget": "选择范围",
    "labelTimeline": "期望时间表",
    "selectTimeline": "选择时间表",
    "labelPower": "技术细节（可选）",
    "placeholderPower": "例如：80米桅杆，200公里骨干网，50个电信站点...",
    "labelDescription": "项目描述",
    "placeholderDescription": "描述您的基础设施项目、目标、技术限制...",
    "continue": "继续",
    "back": "返回",
    "send": "提交请求",
    "sending": "发送中...",
    "success": "报价请求成功！",
    "successMsg": "我们的团队正在分析您的项目，将在48个工作小时内回复详细方案。",
    "recapName": "姓名：",
    "recapCompany": "公司：",
    "recapEmail": "邮箱：",
    "recapPhone": "电话：",
    "recapProjectType": "项目类型：",
    "recapLocation": "地点：",
    "recapBudget": "预算：",
    "recapTimeline": "时间表：",
    "recapPower": "技术细节：",
    "recapDescription": "描述：",
    "projectTypes": [
      {"value": "micro-reseau", "label": "太阳能微电网"},
      {"value": "pompage", "label": "太阳能抽水"},
      {"value": "stockage", "label": "储能"},
      {"value": "recharge-ve", "label": "电动车充电"},
      {"value": "residentiel", "label": "住宅安装"},
      {"value": "industriel", "label": "工业安装"},
      {"value": "btp", "label": "金属结构与土木工程"},
      {"value": "informatique", "label": "信息技术（网络、服务器）"},
      {"value": "audit", "label": "审计与咨询"},
      {"value": "telecom", "label": "电信（铁塔、光纤）"},
      {"value": "transport", "label": "运输与物流"},
      {"value": "autre", "label": "其他项目"}
    ],
    "budgets": [
      {"value": "", "label": "选择范围"},
      {"value": "moins-5k", "label": "低于5,000欧元"},
      {"value": "5k-20k", "label": "5,000 - 20,000欧元"},
      {"value": "20k-100k", "label": "20,000 - 100,000欧元"},
      {"value": "100k-500k", "label": "100,000 - 500,000欧元"},
      {"value": "plus-500k", "label": "超过500,000欧元"}
    ],
    "timelines": [
      {"value": "", "label": "选择时间表"},
      {"value": "urgent", "label": "紧急（1个月内）"},
      {"value": "1-3", "label": "1至3个月"},
      {"value": "3-6", "label": "3至6个月"},
      {"value": "6-12", "label": "6至12个月"},
      {"value": "plus-12", "label": "超过12个月"}
    ],
    "afterTitle": "您的请求之后会发生什么",
    "afterBadge": "接下来？",
    "afterSteps": [
      {"title": "确认", "desc": "您将在1小时内收到包含请求摘要的确认邮件。"},
      {"title": "专家分析", "desc": "我们的技术团队研究您的项目并评估技术可行性。"},
      {"title": "详细报价", "desc": "您在48小时内收到包含技术规格、时间表和价格的完整报价。"},
      {"title": "个性化讨论", "desc": "项目经理联系您讨论报价并回答您的问题。"}
    ],
    "faqTitle": "关于报价的问题",
    "devisFaqs": [
      {"q": "报价真的免费吗？", "a": "是的，绝对免费。您的项目研究和报价编制完全免费，您无需承担任何义务。"},
      {"q": "我多久能收到报价？", "a": "我们承诺在48个工作小时内向您发送详细报价。对于需要现场访问的复杂项目，可能需要5到7天。"},
      {"q": "报价包括什么？", "a": "报价包括：详细技术规格、完整设备清单、安装时间表、保修条款和详细的总价。"},
      {"q": "收到报价后我可以修改项目吗？", "a": "当然！报价是讨论的基础。我们的团队随时为您调整解决方案以满足您的需求和限制。"}
    ]
  },
  "about": {
    "pageTitle": "关于IS TELECOM",
    "pageSubtitle": "非洲电信先驱的故事，自2006年以来致力于连接服务",
    "missionBadge": "我们的使命",
    "missionTitle": "连接非洲到未来的网络",
    "missionDesc1": "IS TELECOM成立于2006年，怀揣雄心勃勃的愿景：建设将非洲人民与世界其他地区连接起来的电信基础设施。从科托努开始，我们与全球最大的电信企业建立了信任网络。",
    "missionDesc2": "如今，作为华为、爱立信、MTN、Orange等公司的合作伙伴，我们已在非洲6个国家部署了超过5,000个电信站点。我们的专业知识覆盖整个产业链：铁塔、光纤、维护以及偏远站点的太阳能供电。",
    "statCountries": "服务国家",
    "statProjects": "完成项目",
    "statExperts": "部署专家",
    "statCapacity": "电信站点部署",
    "certifiedBadge": "ISO 9001认证",
    "certifiedSub": "质量保证",
    "valuesBadge": "我们的价值观",
    "valuesTitle": "每天指引我们前进",
    "values": [
      {"title": "普遍连接", "desc": "我们相信每个社区都应获得可靠的电信网络接入，从大都市到最偏远的村庄。"},
      {"title": "技术卓越", "desc": "我们所有站点均符合最严格的国际标准。我们的团队由华为、爱立信和诺基亚培训和认证。"},
      {"title": "国际覆盖", "desc": "遍布非洲西部和东部的6个国家，我们根据当地环境和特定需求调整连接解决方案。"},
      {"title": "持续创新", "desc": "我们投资于未来的技术：5G、物联网、边缘计算和智慧城市。"},
      {"title": "贴近客户", "desc": "在非洲各地提供个性化支持和全天候NOC技术支持。"},
      {"title": "社会影响", "desc": "我们部署的每个电信站点都能创造当地就业机会，并为教育、医疗和数字经济打开大门。"}
    ],
    "timelineBadge": "我们的历程",
    "timelineTitle": "19年电信领导力",
    "timeline": [
      {"year": "2006", "title": "IS TELECOM成立", "desc": "公司在贝宁科托努成立，使命明确：部署连接西非的电信基础设施。"},
      {"year": "2009", "title": "华为合作伙伴关系", "desc": "与华为技术签署首个西非无线基础设施部署合作伙伴合同。培训我们首批认证团队。"},
      {"year": "2012", "title": "爱立信合作伙伴关系", "desc": "IS TELECOM成为爱立信认证的RAN（无线接入网）设备维护和部署合作伙伴。扩展至多哥和马里。"},
      {"year": "2015", "title": "MTN框架合同", "desc": "与MTN签署多年框架合同，在6个非洲国家部署和维护超过800个电信站点。"},
      {"year": "2019", "title": "4G和光纤部署", "desc": "启动首批4G/LTE部署和光纤骨干网络。超过2,000个电信站点在活跃管理中。"},
      {"year": "2024", "title": "泛非领导者", "desc": "在非洲6个国家部署超过5,000个电信站点。与Orange、Airtel、Vodacom建立战略合作伙伴关系。ISO 9001认证和5G预审资格。"}
    ],
    "certBadge": "认证",
    "certTitle": "我们的认证",
    "certDesc": "保证我们电信基础设施质量和安全的国际标准",
    "certs": [
      {"label": "ISO 9001", "desc": "质量"},
      {"label": "华为认证", "desc": "认可合作伙伴"},
      {"label": "爱立信认证", "desc": "RAN & Core"},
      {"label": "ISO 14001", "desc": "环境"}
    ]
  },
  "solutions": {
    "pageTitle": "我们的解决方案与服务",
    "pageSubtitle": "电信基础设施和定制能源系统，满足您从传输塔到工业太阳能项目的所有需求",
    "processBadge": "我们的流程",
    "processTitle": "我们的工作方式",
    "processSteps": [
      {"title": "审计与咨询", "desc": "分析您的技术需求并进行现场可行性研究，无论是电信还是能源。"},
      {"title": "设计", "desc": "为您的基础设施定制尺寸和详细的工程计划。"},
      {"title": "安装", "desc": "由我们认证的团队按照国际标准执行。"},
      {"title": "监控与维护", "desc": "远程监控和有保障的24/7预防性干预。"}
    ],
    "ctaTitle": "需要定制解决方案？",
    "ctaSubtitle": "我们的工程师免费研究您的电信或能源项目，并为您提出适合您需求和预算的方案。",
    "ctaButton": "申请免费审计",
    "keyFeatures": "主要特点",
    "useCases": "应用案例",
    "requestQuote": "为这个解决方案申请报价",
    "solutions": [
      {"title": "微电网系统", "shortDesc": "为农村和城市电气化提供智能管理的完整解决方案。", "fullDesc": "我们的微电网系统旨在为未连接国家电网的地区提供可靠和可持续的电力。每个解决方案集成光伏板、储能电池、智能逆变器和集中监控系统。", "features": ["自动化生产和消费管理", "通过网页和移动平台实时监控", "带自动警报的预测性维护", "与现有能源的轻松集成", "智能定价和用户管理"], "useCases": ["非洲农村村庄", "城郊地区", "孤立岛屿", "偏远工业场所"]},
      {"title": "太阳能抽水", "shortDesc": "用于农业和供水的太阳能抽水和灌溉系统。", "fullDesc": "我们的太阳能抽水解决方案将阳光转化为饮用水和灌溉用水。适应农村和农业环境，降低运营成本，确保持续供水。", "features": ["高效潜水泵", "集成滴灌系统", "自动流量和压力控制", "兼容深井和水井", "适应极端气候条件的坚固性"], "useCases": ["农业经营", "农村社区", "畜牧业", "植物园"]},
      {"title": "储能", "shortDesc": "采用高性能锂电池的住宅和工业储能解决方案。", "fullDesc": "储能是任何自主太阳能装置的核心。我们提供最新一代锂离子电池解决方案，容量从住宅到工业，结合智能混合逆变器。", "features": ["高能量密度锂电池", "带自动切换的混合逆变器", "智能充放电循环管理", "按需模块化扩展", "最长15年的延长保修"], "useCases": ["独立住宅", "酒店和度假村", "卫生中心", "工业"]},
      {"title": "电动车充电", "shortDesc": "太阳能电动汽车充电站，完整且可持续的解决方案。", "fullDesc": "我们安装100%由太阳能供电的电动汽车充电站。从住宅充电器到公共快速充电站，我们设计适应每种需求的解决方案。", "features": ["快速充电站（最高150千瓦）", "带缓冲存储的太阳能供电", "流量管理和电价优化", "消耗和会话监控", "兼容所有充电标准"], "useCases": ["企业停车场", "服务站", "购物中心", "集体住宅"]},
      {"title": "住宅解决方案", "shortDesc": "适用于住宅、酒店和医疗设施的太阳能系统。", "fullDesc": "我们的住宅解决方案结合了性能、美观和简洁。每个安装都是定制的，根据家庭消耗和现场限制进行尺寸设计。交钥匙安装，包含维护。", "features": ["2至5天交钥匙安装", "包含预防性和纠正性维护", "设备和人工延长保修", "远程生产监控", "自用和余电销售"], "useCases": ["独立住宅", "酒店和旅馆", "诊所和药房", "学校和培训中心"]},
      {"title": "工业解决方案", "shortDesc": "适用于农村地区、采矿作业和工业的高功率系统。", "fullDesc": "针对最苛刻的能源需求，我们部署高功率工业系统。从孤立矿山到工业区，我们的解决方案保证全天候可靠供电，优化投资回报。", "features": ["从100千瓦到数兆瓦的容量", "认证的工业坚固性", "全天候技术支持，专用热线", "可混合柴油/太阳能集成", "集中式多站点监控"], "useCases": ["矿山和采石场", "工业区", "制造工厂", "港口和机场"]},
      {"title": "电信塔与桅杆", "shortDesc": "安装和维护电信塔、自支撑塔和拉线式桅杆。", "fullDesc": "IS TELECOM是非洲电信基础设施部署的主要参与者。我们设计、制造和安装各种尺寸的电信塔：自支撑塔、拉线式桅杆、单极塔和管状桅杆。我们的团队在各种地形上作业，从密集的城市中心到最偏远的农村地区。", "features": ["自支撑塔高达120米", "适用于强风区域的拉线塔", "紧凑型城市单极塔", "基础和土木工程包含在内", "国际标准（ANSI/TIA-222）"], "useCases": ["移动运营商（MTN、Orange、Vodacom）", "微波链路", "广播和电视", "能源（风能、监控）"]},
      {"title": "光纤网络", "shortDesc": "为电信运营商部署光纤网络和传输骨干网。", "fullDesc": "我们端到端部署光纤网络：工程研究、电缆铺设、熔接、性能测试和调试。我们的团队精通GPON、FTTH技术和长距离骨干网。是主要非洲运营商的参考合作伙伴。", "features": ["FTTH（光纤到户）部署", "城际长距离骨干网", "熔接和OTDR测试", "工程研究和详细初步设计", "损坏电缆的维护和修复"], "useCases": ["城域网", "连接偏远站点", "数据中心和电信枢纽", "大学校园和工业区"]},
      {"title": "电信维护与服务", "shortDesc": "为您的基础设施提供预防性、纠正性维护和全天候技术支持。", "fullDesc": "您的网络可靠性取决于严格的维护。IS TELECOM为您的电信基础设施提供定制的维护合同：计划性预防干预、快速纠正性故障排除、全天候技术支持和备件管理。我们的团队由最大的设备制造商培训和认证。", "features": ["带定制计划的预防性维护", "4小时内纠正性干预（保证SLA）", "全天候NOC技术支持", "备件和缓冲库存管理", "月度性能报告（KPI）"], "useCases": ["运营中的电信站点", "数据中心", "无线基站", "交换中心"]}
    ]
  },
  "notFound": {
    "title": "页面未找到",
    "description": "您要查找的页面不存在或已被移动。",
    "backHome": "返回首页"
  },
  "langSelector": {
    "fr": "Français",
    "en": "English",
    "es": "Español",
    "zh": "中文",
    "ar": "العربية"
  }
};